import './search.scss'

class PuppyAuctionSearch {
  _runSetup() {
    this.lotIdInput = document.getElementById('lot-id-search')
    this.searchForm = document.getElementById('pup-search-form')
    this.alertBox = document.getElementById('lot-info-alert')

    if (!this.lotIdInput || !this.searchForm || !this.alertBox) return

    // Event listeners
    this.lotIdInput.addEventListener('input', (e) => this.handleInput(e))
    this.searchForm.addEventListener('submit', (e) => this.handleSubmit(e))

    // Initial check
    if (this.lotIdInput.value.trim().length > 0) {
      this.handleInput({
        target: this.lotIdInput
      }, true) // Force initial search
    }
  }

  handleInput(e, force = false) {
    const searchTerm = e.target.value.trim()
    this.alertBox.style.display = 'none'

    if (searchTerm.length > 0 || force) {
      fetch(`/the-dogs/puppy-auction/purchase/lot-search/search?lot_id=${encodeURIComponent(searchTerm)}`)
        .then(response => {
          if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`)
          return response.json()
        })
        .then(data => this.handleSearchResponse(data))
        .catch(error => this.handleSearchError(error))
    } else {
      this.alertBox.style.display = 'none'
    }
  }

  handleSearchResponse(data) {
    if (data.lot_id && data.given_name) {
      this.showAlert(`Nominator: ${data.given_name} (Lot ${data.lot_id})`, 'success')
    } else {
      this.showAlert('Lot number not found', 'error')
    }
  }

  handleSearchError(error) {
    this.showAlert('Not Found', 'error')
    console.error('Fetch error:', error)
  }

  handleSubmit(e) {
    e.preventDefault()
    const value = this.lotIdInput.value
    const lotId = value.split(':')[0].trim()
    this.lotIdInput.value = lotId
    this.alertBox.style.display = 'none'
    this.searchForm.submit()
  }

  showAlert(message, type = 'success') {
    this.alertBox.innerHTML = message
    this.alertBox.className = `lot-info-alert${type === 'error' ? ' error' : ''}`
    this.alertBox.style.display = 'block'
  }
}

// Enhanced navigation handling
function initializeSearch() {
  // Clear previous instance if exists
  if (window.puppyAuctionSearchInstance) {
    window.puppyAuctionSearchInstance = null
  }
  window.puppyAuctionSearchInstance = new PuppyAuctionSearch()._runSetup()
}

// Navigation event listeners
const navigationEvents = ['DOMContentLoaded', 'pageshow', 'turboujs:load']
navigationEvents.forEach(event => {
  document.addEventListener(event, initializeSearch)
})

// Force initial check on browser navigation
window.addEventListener('popstate', () => {
  setTimeout(initializeSearch, 100)
})